import Joi from "joi";
import { useIntl } from "react-intl";

export type FieldType = 'string' | 'email' | 'number' | 'date' | 'price'| 'NIF';
export type FieldConfig = [string, FieldType, string];

const useValidationSchema = (fields: FieldConfig[]) => {
    const intl = useIntl();

    const schema: { [key: string]: any } = {};

    fields.forEach(([fieldName, fieldType, messageId]) => {
        let fieldSchema;

        switch (fieldType) {

            case 'email':
                    fieldSchema = (fieldSchema || Joi.string())
                        .pattern(/^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/)
                        .required()
                        .messages({
                            'any.required': intl.formatMessage({ id: messageId }),
                            'string.pattern.base': intl.formatMessage({ id: "Validations.GenericMessage.EmailFormat" }), 
                            'string.empty': intl.formatMessage({ id: messageId }), 
                        });
                    break;

            case 'string':
                fieldSchema = Joi.string().empty().required().messages({
                    'any.required': intl.formatMessage({ id: messageId }),
                    'string.base': intl.formatMessage({ id: messageId }),
                    'string.empty': intl.formatMessage({ id: messageId }),
                });
                break;
            case 'number':
                fieldSchema = Joi.number().integer().min(1).required().messages({
                    'any.required': intl.formatMessage({ id: messageId }),
                    'number.base': intl.formatMessage({ id: messageId }),
                    'number.integer': intl.formatMessage({ id: messageId }),
                    'number.min': intl.formatMessage({ id: messageId }),
                });
                break;
            case 'date':
                fieldSchema = Joi.date().required().messages({
                    'any.required': intl.formatMessage({ id: messageId }),
                    'date.base': intl.formatMessage({ id: messageId }),
                });
                break;
            case 'price':
                fieldSchema = Joi.number().min(0).required().messages({
                    'any.required': intl.formatMessage({ id: messageId }),
                    'number.base': intl.formatMessage({ id: messageId }),
                    'number.min': intl.formatMessage({ id: messageId }),
                });
                break;

            case 'NIF':
                fieldSchema =   (  Joi.string())
                .custom((value, helpers) => {

                    if (!value.trim()) {
                        return helpers.error('string.empty');
                    } 

                    if (value.length !== 11) { 
                        return helpers.error('string.length.invalid')
                    } 
                       
                    if (!/^[A-Za-z]{2}/.test(value)) {
                    
                    return helpers.error('string.prefix.missing');
                    }
                    if (/^[A-Za-z]{2}/.test(value))
                    {
                            if (!/^[A-Z]{2}/.test(value)){
                            return helpers.error('string.prefix.uppercase');}
                    }
                    
                    if (!/\d{9}$/.test(value)) {
                        
                        return helpers.error('string.digits.missing');
                    }
                       
                  return value; 
                })
                .required()
                .messages({'string.empty': intl.formatMessage({ id: messageId }),
                'string.length.invalid': intl.formatMessage({ id: 'Validations.GenericMessage.NifLengthInvalid' }),
                'string.prefix.missing': intl.formatMessage({ id: 'Validations.GenericMessage.NifPrefixMissing' }),
                'string.prefix.uppercase': intl.formatMessage({id:'Validations.GenerucMessage.NifPrefixUP'}),
                'string.digits.missing': intl.formatMessage({ id: 'Validations.GenericMessage.NifDigitsMissing' }),
                'any.required': intl.formatMessage({ id: messageId }),
                    
                    
                    
                    
                });
            break;






            default:
                throw new Error(`Tipo de campo não suportado: ${fieldType}, adicionar ao FieldType / Switch-Case.`);
        }

        schema[fieldName] = fieldSchema;
    });

    return Joi.object(schema).unknown(true); // Permitir campos desconhecidos, ver criar plano manutenção (campos dto > do que os campos que queremos verificar)
};

export default useValidationSchema;